import { Trans } from '@lingui/macro'
import Web3Status from 'components/Web3Status'
// import { chainIdToBackendName } from 'graphql/data/util'
// import { useDisableNFTRoutes } from 'hooks/useDisableNFTRoutes'
// import { useIsLandingPage } from 'hooks/useIsLandingPage'
import { useIsNftPage } from 'hooks/useIsNftPage'
import { useIsPoolsPage } from 'hooks/useIsPoolsPage'
import { Box } from 'nft/components/Box'
import { Row } from 'nft/components/Flex'
// import { useProfilePageState } from 'nft/hooks'
// import { ProfilePageStateType } from 'nft/types'
// import { GetTheAppButton } from 'pages/Landing/components/DownloadApp/GetTheAppButton'
import { ReactNode } from 'react'
import { Link, NavLink, NavLinkProps, useLocation } from 'react-router-dom'
import styled from 'styled-components'

import { Z_INDEX } from 'theme/zIndex'
// import { Chain } from 'uniswap/src/data/graphql/uniswap-data-api/__generated__/types-and-hooks'
import { useIsNavSearchInputVisible } from '../../nft/hooks/useIsNavSearchInputVisible'
// import { Bag } from './Bag'
import Blur from './Blur'
import { ChainSelector } from './ChainSelector'
// import { More } from './More'
// import { SearchBar } from './SearchBar'
import Logo from 'assets/images/logo.png'
import clsx from 'clsx'
import * as styles from './style.css'

const Nav = styled.nav`
  // padding: ${({ theme }) => `${theme.navVerticalPad}px 12px`};
  // padding: 0 160px;
  width: 100%;
  height: ${({ theme }) => theme.navHeight}px;
  z-index: ${Z_INDEX.sticky};
`

interface MenuItemProps {
  href: string
  id?: NavLinkProps['id']
  isActive?: boolean
  children: ReactNode
  dataTestId?: string
}

const MenuItem = ({ href, dataTestId, id, isActive, children }: MenuItemProps) => {
  return (
    <NavLink
      to={href}
      className={isActive ? styles.activeMenuItem : styles.menuItem}
      id={id}
      style={{ textDecoration: 'none' }}
      data-testid={dataTestId}
    >
      {children}
    </NavLink>
  )
}

export const PageTabs = () => {
  const { pathname } = useLocation()
  // const { chainId: connectedChainId } = useWeb3React()
  // const chainName = chainIdToBackendName(connectedChainId)

  const isPoolActive = useIsPoolsPage()
  // const isNftPage = useIsNftPage()

  // const shouldDisableNFTRoutes = useDisableNFTRoutes()

  return (
    <>
      <MenuItem href="/swap" isActive={pathname.startsWith('/swap')}>
        <Trans>Swap</Trans>
      </MenuItem>
      {/*<MenuItem*/}
      {/*  href={'/explore' + (chainName !== Chain.Ethereum ? `/${chainName.toLowerCase()}` : '')}*/}
      {/*  isActive={pathname.startsWith('/explore')}*/}
      {/*>*/}
      {/*  <Trans>Explore</Trans>*/}
      {/*</MenuItem>*/}
      {/*{!shouldDisableNFTRoutes && (*/}
      {/*  <MenuItem dataTestId="nft-nav" href="/nfts" isActive={isNftPage}>*/}
      {/*    <Trans>NFTs</Trans>*/}
      {/*  </MenuItem>*/}
      {/*)}*/}

      {/*<Box display={{ sm: 'flex', lg: 'none', xxl: 'flex' }} width="full">*/}
      <MenuItem href="/pool" dataTestId="pool-nav-link" isActive={isPoolActive}>
        <Trans>Pool</Trans>
      </MenuItem>
      {/*</Box>*/}
      {/*<More />*/}
    </>
  )
}

const Navbar = ({ blur }: { blur: boolean }) => {
  const isNftPage = useIsNftPage()
  // const isLandingPage = useIsLandingPage()
  // const sellPageState = useProfilePageState((state) => state.state)
  // const navigate = useNavigate()
  const isNavSearchInputVisible = useIsNavSearchInputVisible()

  // const { account } = useWeb3React()
  // const [accountDrawerOpen, toggleAccountDrawer] = useAccountDrawer()
  // const handleUniIconClick = useCallback(() => {
  //   if (account) {
  //     return
  //   }
  //   if (accountDrawerOpen) {
  //     toggleAccountDrawer()
  //   }
  //   navigate({
  //     pathname: '/',
  //     search: '?intro=true',
  //   })
  // }, [account, accountDrawerOpen, navigate, toggleAccountDrawer])

  return (
    <>
      {blur && <Blur />}
      <Nav>
        <div className="px-5 xl:px-[160px] py-3">
          <Box display="flex" height="full" flexWrap="nowrap">
            <Box className={styles.leftSideContainer}>
              {/* <Box className={styles.logoContainer}>
              <UniIcon
                // width="48"
                // height="48"
                width="36"
                height="36"
                data-testid="logo"
                className={styles.logo}
                clickable={!account}
                onClick={handleUniIconClick}
              />
            </Box> */}
              <Link to="/swap" className="flex items-center gap-2.5">
                <img
                  src={Logo}
                  alt="Logo"
                  className="w-[26px] lg:w-[32px] aspect-square"
                  width={128}
                  height={128}
                  loading="lazy"
                />

                <p className="text-base lg:text-lg font-[450] text-black">WorldSwap</p>
              </Link>

              <div className="hidden lg:flex items-center gap-2 ml-6">
                <NavLink
                  to="/swap"
                  className={({ isActive }: { isActive: boolean }) =>
                    clsx(
                      'text-sm font-medium',
                      'px-3 py-1 rounded-lg',
                      isActive ? 'text-[#008095] bg-[#F1FAFC]' : 'text-light7'
                    )
                  }
                >
                  <span>Swap</span>
                </NavLink>

                <NavLink
                  to="/pool"
                  className={({ isActive }: { isActive: boolean }) =>
                    clsx(
                      'text-sm font-medium',
                      'px-3 py-1 rounded-lg',
                      isActive ? 'text-[#008095] bg-[#F1FAFC]' : 'text-light7'
                    )
                  }
                >
                  <span>Pool</span>
                </NavLink>
              </div>

              {/* {!isNftPage && (
                <Box display={{ sm: 'flex', lg: 'none' }}>
                  <ChainSelector leftAlign={true} />
                </Box>
              )} */}
              {/* <Row display={{ sm: 'none', lg: 'flex' }}>
                <PageTabs />
              </Row> */}
            </Box>

            <Box
              className={styles.searchContainer}
              {...(isNavSearchInputVisible && {
                display: 'flex',
              })}
            >
              {/*<SearchBar />*/}
            </Box>
            <Box className={styles.rightSideContainer}>
              <Row gap="8">
                <Box position="relative" display={isNavSearchInputVisible ? 'none' : { sm: 'flex' }}>
                  {/*<SearchBar />*/}
                </Box>
                {/*{isNftPage && sellPageState !== ProfilePageStateType.LISTING && <Bag />}*/}
                {!isNftPage && <ChainSelector />}
                {/*{isLandingPage && <GetTheAppButton />}*/}
                <Web3Status />
              </Row>
            </Box>
          </Box>
        </div>
      </Nav>
    </>
  )
}

export default Navbar
